import React from 'react';
import PropTypes from 'prop-types';
import { DefaultButton } from './defaultButton';

export function LoginButton({
  content, onClick, disabled, className,
}) {
  return (
    <DefaultButton onClick={onClick} disabled={disabled} className={className}>
      {content}
    </DefaultButton>
  );
}

LoginButton.propTypes = {
  content: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  className: PropTypes.string,

};

LoginButton.defaultProps = {
  onClick: () => null,
  disabled: false,
  className: null,
};

export default LoginButton;
